import { HelpTooltip } from '../../../components/common/HelpTooltip';
import { brandConfig } from '../../../config/brands';

/** 案件フォームの「ブランド」見出しの右に出すヘルプ (新規登録ページ・素材パネルの登録モーダルで共用)。 */
export function BrandFieldHelp() {
  const productLabel = brandConfig.labels.productShort;
  return (
    <HelpTooltip ariaLabel="ブランド欄のヘルプ">
      <p style={{ margin: '0 0 6px 0' }}>
        {productLabel}をブランド（マスター）に紐づけます。任意ですが、紐づけるとそのブランドに登録したロゴ・配色や書体（トーン＆マナー）・ブランドカット・サウンドロゴ・守るルールを、静止画や動画の生成で自動的に使えます。
      </p>
      <p style={{ margin: '0 0 6px 0' }}>
        一覧に無いブランドは「＋ ブランド新規登録」から作れます。サイトのURLを入れると、名前・説明・配色・書体・ロゴの候補をAIが提案します（有料・内容を確認してから登録）。
      </p>
      <p style={{ margin: 0 }}>
        「ブランド（自由入力）」はブランドをマスターに登録せず名前だけ残したいときに使います。マスターを選ぶとその名前が自動で入り、選ばなければ自由入力の値がそのまま表示名になります。
      </p>
    </HelpTooltip>
  );
}
